<div class="py-3">
	<mat-card>
		<mat-card-title class="px-3 pt-3">Konfiguracja szablonów</mat-card-title>

		<mat-card-content class="p-3">
			<form [formGroup]="templatesForm">
				<div class="d-flex justify-content-end mb-3">
					<button
						mat-raised-button
						color="primary"
						type="button"
						(click)="addTemplateRow()"
						[disabled]="isSaving()"
					>
						Dodaj szablon
					</button>
				</div>

				<div formArrayName="rows" class="d-flex flex-column gap-3">
					@for (rowGroup of templateRows.controls; track rowGroup.controls.rowId.value) {
						<div class="row g-3 align-items-start" [formGroupName]="$index">
							<div class="col-8">
								<mat-form-field appearance="outline" class="w-100">
									<mat-label>Szablon</mat-label>
									<mat-select formControlName="templateId" [disabled]="isSaving()">
										@for (t of templates(); track t.id) {
											<mat-option [value]="t.id">{{ t.name }}</mat-option>
										}
									</mat-select>

									@if (rowGroup.controls.templateId.touched && rowGroup.controls.templateId.invalid) {
										<mat-error>Wybierz szablon</mat-error>
									}
								</mat-form-field>
							</div>

							<div class="col-3">
								<mat-form-field appearance="outline" class="w-100">
									<mat-label
										matTooltip="Określa, kiedy wysłać automatyczny mail względem terminu płatności faktury. Wartości ujemne (np. -2, -5) = tyle dni PRZED terminem, wartości dodatnie (np. 2, 5) = tyle dni PO terminie."
										matTooltipPosition="above"
										matTooltipShowDelay="250"
										matTooltipHideDelay="100"
									>
										Liczba dni
									</mat-label>

									<input matInput type="number" formControlName="days" [disabled]="isSaving()" />

									@if (rowGroup.controls.days.touched && rowGroup.controls.days.invalid) {
										<mat-error>Podaj liczbę dni</mat-error>
									}
								</mat-form-field>
							</div>

							<div class="col-1 d-flex justify-content-end">
								<button
									class="mx-2 d-flex justify-content-center align-items-center delete-btn"
									mat-icon-button
									color="warn"
									type="button"
									(click)="removeTemplateRow($index)"
									[disabled]="isSaving()"
								>
									<i class="fa-solid fa-trash"></i>
								</button>
							</div>
						</div>

						@if ($index < templateRows.length - 1) {
							<mat-divider></mat-divider>
						}
					}
				</div>

				<div class="d-flex justify-content-end gap-2 mt-3">
					<button
						mat-flat-button
						color="primary"
						type="button"
						(click)="saveTemplates()"
						[disabled]="templatesForm.invalid || templateRows.length === 0 || isSaving()"
					>
						Zapisz
					</button>
				</div>
			</form>
		</mat-card-content>
	</mat-card>
</div>
